module.exports = __webpack_public_path__ + "img/aboutus_companyinfo.fb8124b8.png";